'use client';

import dynamic from 'next/dynamic';
import { NextIntlClientProvider, useMessages } from 'next-intl';
const AnalyticsScripts = dynamic(() => import('@/lib/analytics/scripts').then(mod => mod.AnalyticsScripts), {
  ssr: false
});
const CookieModal = dynamic(() => import('@/components/cookie-modal').then(mod => mod.default), {
  ssr: false
});
const Toaster = dynamic(() => import('@/components/ui/toaster').then(mod => mod.Toaster), {
  ssr: false
});
export function DeferredComponents({
  locale
}: {
  locale: string;
}) {
  // Use messages from the parent provider if available
  const parentMessages = useMessages();
  return <NextIntlClientProvider messages={parentMessages} locale={locale} data-sentry-element="NextIntlClientProvider" data-sentry-component="DeferredComponents" data-sentry-source-file="deferred-components.tsx">
      <Toaster data-sentry-element="Toaster" data-sentry-source-file="deferred-components.tsx" />
      <AnalyticsScripts data-sentry-element="AnalyticsScripts" data-sentry-source-file="deferred-components.tsx" />
      <CookieModal data-sentry-element="CookieModal" data-sentry-source-file="deferred-components.tsx" />
    </NextIntlClientProvider>;
}